import React from 'react';
import Spinner from '@atlaskit/spinner';

const IsLoadingDiv = (props) => {
	if (!props.isLoading)
		return <div className="force-width">{props.children}</div>;

	return (
		<div
			className="force-width"
			style={{
				alignItems: 'center',
				justifyContent: 'center',
				position: 'relative',
			}}
		>
			{props.isLoading && (
				<div
					style={{
						display: 'flex',
						width: '100%',
						height: '100%',
						alignItems: 'center',
						justifyContent: 'center',
						position: 'absolute',
						opacity: '50%',
						padding: '0px 15px 15px 15px',
						zIndex: 94,
						backgroundColor: '#FFFFFFFF',
					}}
				>
					<Spinner size="xlarge" />
				</div>
			)}
			{props.children}
		</div>
	);
};

export default IsLoadingDiv;
